import { render } from "./TicketList.html?vue&type=template&id=3c9736de&scoped=true&ts=true"
import script from "./TicketList.ts?vue&type=script&lang=ts"
export * from "./TicketList.ts?vue&type=script&lang=ts"

import "./TicketList.css?vue&type=style&index=0&id=3c9736de&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9736de"]])

export default __exports__